import { SUPPORT_EMAIL, WHATSAPP_NUMBER_DISPLAY } from '@/lib/support';

/**
 * Help & Support questions (Figma T4). The first answer is the designed copy; the others use
 * only facts stated elsewhere in the designs (plan cards, order details, claims) and should be
 * reviewed by the support team before release.
 */
export const HELP_FAQS = [
  {
    id: 'file-claim',
    question: 'How do I file a claim?',
    answer: `Open My Plans, choose the product and tap File a claim. Add a few photos and a short description, then submit. You can also file on WhatsApp at ${WHATSAPP_NUMBER_DISPLAY}.`,
  },
  {
    id: 'claim-resolution',
    question: 'How is my claim resolved?',
    answer:
      'Our team reviews your claim, usually within 2 working days. Approved claims are resolved by repair, replacement or store credit. You can follow every step under Claims.',
  },
  {
    id: 'accidental-damage',
    question: 'What does Accidental Damage Protection cover?',
    answer:
      'Accidental damage to your product, such as drops, cracks and broken parts. The exact cover is listed in your plan’s terms under Plan details.',
  },
  {
    id: 'extended-warranty',
    question: 'What does Extended Warranty cover?',
    answer:
      'Manufacturing defects that appear during your plan, with repairs up to the invoice value. The exact cover is listed in your plan’s terms under Plan details.',
  },
  {
    id: 'add-plan-later',
    question: 'Can I add a plan after I’ve bought the product?',
    answer:
      'Yes. You can add Accidental Damage or Extended Warranty while your order is on the way and for 30 days after delivery. Open the order in Orders and tap Add protection.',
  },
  {
    id: 'cover-start',
    question: 'When does my cover start?',
    answer: 'Your cover start and end dates are shown on the plan in My Plans. A plan added before delivery can start right away.',
  },
  {
    id: 'update-mobile',
    question: 'How do I update my mobile number?',
    answer: `Your account is linked to the mobile number you gave at checkout. To change it, message us on WhatsApp at ${WHATSAPP_NUMBER_DISPLAY} or email ${SUPPORT_EMAIL}.`,
  },
];
